/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do driver prices change in F1 Fantasy?`)
};

const es_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué cambian los precios de los pilotos en F1 Fantasy?`)
};

const de_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ändern sich Fahrerpreise in F1 Fantasy?`)
};

const nl_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom veranderen coureursprijzen in F1 Fantasy?`)
};

const fr_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les prix des pilotes changent-ils dans F1 Fantasy ?`)
};

const it_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché i prezzi dei piloti cambiano in F1 Fantasy?`)
};

const pt_br2_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os preços dos pilotos mudam no F1 Fantasy?`)
};

const pt_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que razão os preços dos pilotos mudam no F1 Fantasy?`)
};

const ja_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasyでドライバーの価格が変動するのはなぜですか？`)
};

const zh_f1_bb_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy 中车手价格为什么会变化？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_bb_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_bb_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_bb_faq1_q", locale)
	if (locale === "en") return en_f1_bb_faq1_q(inputs)
	if (locale === "es") return es_f1_bb_faq1_q(inputs)
	if (locale === "de") return de_f1_bb_faq1_q(inputs)
	if (locale === "nl") return nl_f1_bb_faq1_q(inputs)
	if (locale === "fr") return fr_f1_bb_faq1_q(inputs)
	if (locale === "it") return it_f1_bb_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_bb_faq1_q(inputs)
	if (locale === "pt") return pt_f1_bb_faq1_q(inputs)
	if (locale === "ja") return ja_f1_bb_faq1_q(inputs)
	return zh_f1_bb_faq1_q(inputs)
};